import React from 'react';
import ServicesIndustrial from '../industrial/ServicesIndustrial';
import PageHeader from '../industrial/PageHeader';
import SEO from '../SEO';
import { breadcrumbSchema } from '../../utils/structuredData';

const ServicesPage: React.FC = () => {
  const breadcrumbs = breadcrumbSchema([
    { name: 'Inicio', url: 'https://junisama.com.co' },
    { name: 'Servicios', url: 'https://junisama.com.co/servicios' }
  ]);

  return (
    <>
      <SEO
        title="Servicios | Junisama - Baños Portátiles VIP, Estándar y Eléctricos | Catálogo Completo"
        description="Servicios completos de baños portátiles: VIP, estándar, eléctricos, para discapacitados, lavamanos Aquastand, trailers de lujo, operarios certificados y puntos ecológicos. Soluciones para festivales, bodas, construcción y eventos corporativos. Cotiza ahora ☎ +57 350 708 9584"
        keywords="servicios baños portátiles, alquiler baños VIP Colombia, baños portátiles eléctricos, baños discapacitados, lavamanos portátiles Aquastand, trailer lujo eventos, operarios certificados, puntos ecológicos, catálogo servicios sanitarios"
        url="/servicios"
        structuredData={breadcrumbs}
      />
      <PageHeader
        title="SERVICIOS"
        titleHighlight="ESPECIALIZADOS"
        subtitle="Infraestructura sanitaria robusta para eventos de cualquier magnitud. Tecnología avanzada y cumplimiento normativo garantizado."
      />

      <ServicesIndustrial />
    </>
  );
};

export default ServicesPage;